var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "5.5 797.5 175 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -64.999,
    y1: 1381.5,
    x2: -64.999,
    y2: 1206.5,
    gradientTransform: "translate(158 -409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3bb1dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60f0ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M151.333 799.216c7.292 0 14.183 2.861 19.388 8.062 5.204 5.205 8.062 12.097 8.062 19.389v116.666c0 7.292-2.859 14.184-8.062 19.387-5.205 5.205-12.097 8.064-19.388 8.064H34.667c-7.292 0-14.183-2.859-19.387-8.064-5.205-5.203-8.064-12.095-8.064-19.387V826.667c0-7.292 2.859-14.184 8.064-19.389 5.205-5.201 12.096-8.062 19.387-8.062h116.666m0-1.716H34.667C18.625 797.5 5.5 810.625 5.5 826.667v116.666c0 16.042 13.125 29.167 29.167 29.167h116.666c16.042 0 29.167-13.125 29.167-29.167V826.667c0-16.042-13.125-29.167-29.167-29.167z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3BB1DC",
    d: "M53.053 835.533h49.612c9.149 0 16.499 2.085 22.019 6.289 5.52 4.203 8.293 10.521 8.293 19.015 0 5.147-1.258 9.552-3.773 13.212-2.518 3.659-6.119 6.521-10.811 8.521v.283c6.293 1.346 11.066 4.318 14.297 8.923 3.231 4.633 4.861 10.408 4.861 17.387 0 4.003-.715 7.75-2.145 11.209-1.43 3.487-3.661 6.493-6.721 9.006-3.06 2.517-6.947 4.521-11.724 6.006-4.774 1.488-10.438 2.231-17.013 2.231H53.053V835.533zm17.872 42.748h29.167c4.29 0 7.863-1.201 10.723-3.66 2.86-2.459 4.289-5.948 4.289-10.525 0-5.146-1.287-8.775-3.858-10.862-2.573-2.089-6.291-3.146-11.152-3.146H70.925v28.193zm0 44.752h31.597c5.435 0 9.666-1.404 12.642-4.234 3.001-2.802 4.519-6.806 4.519-11.953 0-5.061-1.488-8.921-4.519-11.667-3.031-2.744-7.207-4.06-12.642-4.06H70.925v31.914z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.3d6fae262a589c1d8fa0a13527bd909a.svg";
export { ForwardRef as ReactComponent };